// extracted by mini-css-extract-plugin
export default {"settingsForm":"cycleSettings_settingsForm__x5Gfa","inputSettings":"cycleSettings_inputSettings__UYFf4"};